import React, { useState, useEffect, useRef } from 'react';

const SearchInput = ({ classes, listData, onInputChange, placeHolder,value='' }) => {
  const [inputValue, setInputValue] = useState(value);
  const [filteredProfessions, setFilteredProfessions] = useState([]);
  const inputRef = useRef(null);

  useEffect(() => {
    const handleDocumentClick = (e) => {
      if (inputRef.current && !inputRef.current.contains(e.target)) {
        setFilteredProfessions([]);
      }
    };
    document.addEventListener('click', handleDocumentClick);

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, []); 

  useEffect(()=>{setInputValue(value)},[value])

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    const filtered = listData?.filter((profession) =>
      profession.name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredProfessions(filtered);
    
    onInputChange(value);
  };

  const handleProfessionSelect = (profession) => {
    setInputValue(profession.name);
    setFilteredProfessions([]); 
    onInputChange(profession.name);
  };

  return (
    <div className='col-span-3 relative' ref={inputRef}>
      <input
        type="text"
        placeholder={placeHolder}
        className={`${classes}`}
        value={inputValue}
        onChange={handleInputChange}
      />
      {filteredProfessions?.length > 0 && (
        <ul className="scroller absolute top-[54px] left-0 right-0 bg-white border border-gray-300 rounded-lg shadow-lg max-h-[200px] lg:max-h-[110px] xl:max-h-[160px] overflow-y-auto z-[1]">
          {filteredProfessions?.filter(profession => profession.searchable).map((profession)=> (
            <li
              key={profession.id}
              className="cursor-pointer px-4 py-2 hover:bg-[#EBF7FF]"
              onClick={() => handleProfessionSelect(profession)}
            >
              {profession.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchInput;
